var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FitWxPhonex',{staticClass:"downloadWx"},[_c('button',{on:{"click":_vm.eGoDownload}},[_vm._v("獲取")])])}
var staticRenderFns = []

export { render, staticRenderFns }